const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/medic_aps/EmptyRouterView.vue");
const medicAps = () => /* webpackChunkName: "HomeMedicAps" */ import("./../views/medic_aps/Home.vue");
const contrarref = () => /* webpackChunkName: "Contrarrefs" */ import("./../views/medic_aps/contrarref/Contrarrefs.vue");
const MedicAtention = () => /* webpackChunkName: "MedicAtentions" */ import("./../views/medic_aps/medic_atention/medicAtentions.vue");
const TreatingProfessional = () => /* webpackChunkName: "TreatingProfessional" */ import("./../views/medic_aps/telemedical/TreatingProfessional.vue");
const Pharmacy = () => /* webpackChunkName: "Pharmacy" */ import("./../views/medic_aps/pharmacy/Pharmacy.vue");
const testZoom = () => /* webpackChunkName: "testZoom" */ import("./../views/medic_aps/testZoom.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/administrative/archive_request/ArchiveRequestHome.vue");
const Document = () => /* webpackChunkName: "DocumentGeneral" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/medicAps",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "medicApsHome",
        component: medicAps,
      },
      {
        path: "atencionMedica",
        name: "medicAntentionAps",
        component: MedicAtention,
      },
      {
        path: "contrareferencia",
        name: "medicContrarefAps",
        component: contrarref,
      },
      {
        path: "interconsulta-profesional-tratante",
        name: "treatingProfesional",
        component: TreatingProfessional,
      },
      {
        path: "farmacia-medico-hosp",
        name: "pharmacyMedicAps",
        component: Pharmacy,
      },
      {
        path: "solicitud-archivo",
        name: "medicApsArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "zoom",
        name: "zoom",
        component: testZoom,
      },
      {
        path: "documentacion",
        name: "medicApsDocumentation",
        component: Document,
      },
    ],
  },
];
